import {
  Dialog,
  DialogContent,
  Button,
  Stack,
  Typography,
  Box,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { useChatInteract } from "@/client/useChatInteractV2";
import { useNavigate } from "react-router-dom";
import { useSetRecoilState } from "recoil";
import { companyState } from "@/client/state";

type Props = {
  open: boolean;
  onClose: () => void;
  id: string;
};

const SuccessModal: React.FC<Props> = ({ open, onClose, id }) => {
  const { clear } = useChatInteract();
  const navigate = useNavigate();
  const setCompanyState = useSetRecoilState(companyState);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent>
        <Stack alignItems="center" spacing={2} py={3}>
          {/* Green circle with white check */}
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              backgroundColor: "green",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CheckIcon sx={{ color: "white", fontSize: 50 }} />
          </Box>

          <Typography variant="h6" align="center" fontWeight={700}>
            Report Successfully Generated
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center">
            The company data has been successfully uploaded and the report is
            ready
          </Typography>
        </Stack>

        {/* Horizontal buttons */}
        <Stack direction="row" spacing={2} justifyContent="center">
          <Button variant="outlined" onClick={onClose}>
            Back to List
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              setCompanyState(id);
              clear();
              navigate("/");
            }}
            sx={{ color: "secondary.contrastText", textTransform: "none" }}
          >
            Open Chat
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessModal;
